var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),(this.categories.length)?_c('books',{attrs:{"categories":this.categories,"category":this.categories[0],"url":"/library"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }